import Vue from 'vue'
import Router from 'vue-router'
import AuthRouter, { AuthFilter } from './auth/router'
import DeviceRouter, {DeviceFilter} from './device/router'
import DeviceBase from './device/components/DeviceBase'
import VoiceMessageRouter from './voicemessage/router'
import AnalyticsRouter from './analytics/router'
import AccountRouter from './account/router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/d/:deviceId',
      component: DeviceBase,
      children: [
        ...VoiceMessageRouter,
        ...AnalyticsRouter,
        ...AccountRouter
      ]
    },
    DeviceRouter,
    AuthRouter
  ]
})

router.beforeEach(AuthFilter)
router.beforeEach(DeviceFilter)

export default router
